import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit';

import { LocationField, LocationFields } from '../../../../../../components/Field/common/LocationField';
import { TimeContainer } from './TimeContainer';
import { UndergroundContainer } from './UndergroundContainer';
import { Highway } from '../../../../../../components/Field/common/LocationField/Highway';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const LocationFieldContainer: React.FC = () => {
  const {
    published,
    geo: { undergrounds, highways },
  } = useOfferContext();

  return (
    <LocationFields published={published}>
      <>
        {!!undergrounds &&
          undergrounds.map(underground => {
            return (
              <LocationField
                key={underground.name}
                location={<UndergroundContainer underground={underground} />}
                time={<TimeContainer underground={underground} />}
              />
            );
          })}

        {!!highways &&
          highways.map(highway => {
            return (
              <LocationField
                key={highway.name}
                location={<Highway name={highway.name} />}
                time={<InlineText1 color="gray60_100">{highway.distance}</InlineText1>}
              />
            );
          })}
      </>
    </LocationFields>
  );
};
